import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/dashboard-sidebar";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
  beforeLoad: async ({ location }) => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      throw redirect({
        to: "/auth",
        search: { mode: "signin", redirect: location.href },
      });
    }
    return { user: data.user };
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <SidebarProvider defaultOpen>
      <div className="flex min-h-[calc(100vh-5rem)] w-full">
        <DashboardSidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <div className="sticky top-20 z-30 flex h-12 items-center gap-2 border-b border-white/5 bg-background/60 backdrop-blur-xl px-4">
            <SidebarTrigger className="text-muted-foreground hover:text-foreground" />
            <span className="text-xs uppercase tracking-widest text-muted-foreground/70">
              Dashboard
            </span>
          </div>
          <main className="relative flex-1 min-w-0">
            {/* Ambient premium glow shared across all authenticated pages */}
            <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] bg-gradient-to-b from-primary/[0.07] via-primary/[0.02] to-transparent" aria-hidden />
            <div className="pointer-events-none absolute -top-24 left-1/2 h-96 w-[720px] -translate-x-1/2 rounded-full bg-primary/[0.08] blur-3xl" aria-hidden />
            <div className="relative animate-fade-in">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
